"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _colors = require("HubStyleTokens/colors");

var _reactRedux = require("react-redux");

var _MerchandiseSelectors = require("pricing-pages-unified-ui/selectors/MerchandiseSelectors");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _UICloseButton = _interopRequireDefault(require("UIComponents/button/UICloseButton"));

var _PricingSelectors = require("../../../selectors/PricingSelectors");

var _CurrencySelectors = require("../../../selectors/CurrencySelectors");

var _PriceDisplay = _interopRequireDefault(require("../../common/pricing/PriceDisplay"));

var _ChargeTypes = require("self-service-api/constants/ChargeTypes");

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _MerchandiseIdBillingNameKeyMap = _interopRequireDefault(require("self-service-api/constants/MerchandiseIdBillingNameKeyMap"));

function _templateObject3() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  position: absolute;\n  top: 10px;\n  right: 10px;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  font-weight: 600;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  background-color: ", ";\n  padding: 16px 24px;\n  margin-bottom: 8px;\n  position: relative;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var ShoppingCartItemContainer = _styledComponents.default.div.withConfig({
  displayName: "ShoppingCartItem__ShoppingCartItemContainer",
  componentId: "sc-1kon1hs-0"
})(_templateObject(), _colors.GYPSUM);

var PlanTitle = _styledComponents.default.div.withConfig({
  displayName: "ShoppingCartItem__PlanTitle",
  componentId: "sc-1kon1hs-1"
})(_templateObject2());

var CloseButton = (0, _styledComponents.default)(_UICloseButton.default).withConfig({
  displayName: "ShoppingCartItem__CloseButton",
  componentId: "sc-1kon1hs-2"
})(_templateObject3());

function ShoppingCartItem(_ref) {
  var additionalUnitQuantity = _ref.additionalUnitQuantity,
      merchandiseId = _ref.merchandiseId,
      onRemove = _ref.onRemove,
      unit = _ref.unit;
  var currencyCode = (0, _reactRedux.useSelector)(_CurrencySelectors.activeCurrencySelector);
  var products = (0, _reactRedux.useSelector)(_MerchandiseSelectors.merchandiseSelector);
  var calculatePriceAndItemConfig = (0, _reactRedux.useSelector)(_PricingSelectors.getCalculatePriceAndItemConfigSelector);
  var priceObject = calculatePriceAndItemConfig({
    merchandiseId: merchandiseId,
    additionalUnitQuantity: additionalUnitQuantity
  });
  var recurring = products[merchandiseId].chargeType === _ChargeTypes.RECURRING;
  var price = recurring ? priceObject.monthly.calculatedPrice : priceObject.oneTimeFee.calculatedPrice;
  var billingNameKey = _MerchandiseIdBillingNameKeyMap.default[merchandiseId];
  return _react.default.createElement(ShoppingCartItemContainer, {
    "data-selenium-class": "shopping-cart-item-container"
  }, _react.default.createElement(PlanTitle, null, _react.default.createElement(_FormattedMessage.default, {
    "data-selenium-class": "shopping-cart-item-title",
    message: "pricing-pages.merchandise." + billingNameKey + ".title"
  })), _react.default.createElement("div", null, _react.default.createElement(_PriceDisplay.default, {
    price: price,
    currencyCode: currencyCode
  }), recurring && _react.default.createElement(_FormattedMessage.default, {
    message: "bundles.shoppingCart.perMonth",
    useGap: true
  }), unit && ' | ', unit), _react.default.createElement(CloseButton, {
    color: _colors.EERIE,
    onClick: onRemove,
    size: "medium",
    "data-selenium-class": "shopping-cart-item-remove"
  }, "x"));
}

ShoppingCartItem.propTypes = {
  merchandiseId: _propTypes.default.number.isRequired,
  additionalUnitQuantity: _propTypes.default.number,
  onRemove: _propTypes.default.func.isRequired,
  unit: _propTypes.default.object
};
var _default = ShoppingCartItem;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/components/bundle-page/shopping-cart/ShoppingCartItem.js
// module id = 461
// module chunks = 5 6